import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { resetReportState, getReport as onGetReports } from "../../../../store/report/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";

const Report = () => {
  const dispatch = useDispatch();

  const {
    reports,
    isReportCreated,
    isReportSuccess,
    loading,
    error,
    companies,
    companyLoading,
  } = useSelector((state) => ({
    reports: state.Report.reports,
    isReportCreated: state.Report.isReportCreated,
    isReportSuccess: state.Report.isReportSuccess,
    loading: state.Report.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Report.error,
  }));

  const [reportList, setReportList] = useState([]);
  const [report, setReport] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setReportList(reports);
  }, [reports]);

  useEffect(() => {
    if (!isEmpty(reports)) setReportList(reports);
  }, [reports]);


  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetReports({ id: "1", ok: "ok" }, "/sales-tax"));
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (
      obj.data &&
      obj?.data?.user?.user_position &&
      obj?.data?.user?.user_position?.position_role
    ) {
      setCompanyName({
        label: obj?.data?.user.user_company.name,
        value: obj?.data?.user.user_company.id,
      });
      setRoles(obj?.data?.user?.user_position?.position_role.method);
    } else setRoles(null);

    if (obj?.data)
      setUserType(obj?.data?.userType);
  }, [dispatch, reports, isSearch]);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    setReport(reports);
  }, [reports]);

  useEffect(() => {
    if (!isEmpty(reports)) {
      setReport(reports);
    }
  }, [reports]);

  useEffect(() => {
    setReportList(reports);
  }, [reports]);

  useEffect(() => {
    if (!isEmpty(reports)) setReportList(reports);
  }, [reports]);

  // Column
  const columns = useMemo(
    () => [
      {
        Header: "Report",
        accessor: "report_name",
        filterable: true,
      },
      {
        Header: "Code",
        accessor: "report_code",
        filterable: true,
      },
      {
        Header: "Parent Report",
        accessor: "par_dep.report_name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "report_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}</span>
              );
            case "ACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-info">
                  {cell.value}</span>
              );
            case "INACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-danger">
                  {cell.value}</span>
              );
            default:
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}</span>
              );
          }
        },
      },
    ], []
  );

  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: reportList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  function handleReportStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetReports(param));
  }

  document.title = "Reports | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={reportList} />
      <Container fluid>
        <BreadCrumb title="Reports" pageTitle="Human Resources" />
        <Row>
          <Col lg={12}>
            <Card id="reportList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Report Data &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>    Export
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select created date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Select Status"
                                onChange={(e) => {
                                  handleReportStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            className={""}
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                className={"" + generateFilterable(column)}
                                {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>
                          {"<"}      </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Report;
